<!-- Loader -->
<div style="height: 3px; width: 100%;">
  <mat-progress-bar *ngIf="isSubmitting" mode="indeterminate" color="primary"></mat-progress-bar>
</div>

<!-- Content -->
<div class="create-container">
  
  <!-- Header -->
  <div class="create-header">
    <div class="header-title">
      <button mat-icon-button (click)="onCancel()" class="back-btn">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h1>Create First Meeting</h1>
    </div>
  </div>

  <!-- Form Content -->
  <div class="create-content">
    <form [formGroup]="form">
      
      <!-- Client Information Section -->
      <div class="form-section">
        <h3 class="section-title">
          <mat-icon>person</mat-icon>
          Client Information
        </h3>
        
        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label><span class="required-asterisk">*</span> Client Name</mat-label>
            <input matInput formControlName="clientName" placeholder="Enter client name">
            <mat-error *ngIf="form.get('clientName')?.hasError('required')">
              Client name is required
            </mat-error>
            <mat-error *ngIf="form.get('clientName')?.hasError('minlength')">
              Name must be at least 2 characters
            </mat-error>
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label><span class="required-asterisk">*</span> Phone Number</mat-label>
            <input matInput formControlName="phoneNumber" placeholder="Enter 10-digit phone number">
            <mat-error>{{ getPhoneNumberError() }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label><span class="required-asterisk">*</span> Email ID</mat-label>
            <input matInput formControlName="emailId" placeholder="Enter email address">
            <mat-error>{{ getEmailError() }}</mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Debit Information Section -->
      <div class="form-section">
        <div class="section-header">
          <h3 class="section-title">
            <mat-icon>credit_card</mat-icon>
            Debit Information
          </h3>
          <button type="button" mat-raised-button color="primary" (click)="addDebt()" class="add-btn">
            <mat-icon>add</mat-icon>
            Add Debt
          </button>
        </div>

        <div class="items-list" *ngIf="debtList.length > 0">
          <div *ngFor="let debt of debtList; let i = index" class="item-row debt-row">
            <mat-form-field class="form-field">
              <mat-label>Bank Name</mat-label>
              <input matInput [(ngModel)]="debt.bankName" [ngModelOptions]="{standalone: true}" placeholder="Enter bank name">
            </mat-form-field>

            <mat-form-field class="form-field">
              <mat-label>Balance</mat-label>
              <input matInput type="number" [(ngModel)]="debt.balance" [ngModelOptions]="{standalone: true}" placeholder="Enter balance">
            </mat-form-field>

            <button type="button" mat-icon-button color="warn" (click)="removeDebt(i)" class="remove-btn">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div *ngIf="debtList.length === 0" class="empty-state">
          <p>No debit information added yet</p>
        </div>
      </div>

      <!-- Family Income Section -->
      <div class="form-section">
        <h3 class="section-title">
          <mat-icon>attach_money</mat-icon>
          Family Income
        </h3>

        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Debtor's Income</mat-label>
            <input matInput formControlName="debtorIncome" placeholder="Enter debtor's income">
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label>Spouse Income</mat-label>
            <input matInput formControlName="spouseIncome" placeholder="Enter spouse income">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Child Tax</mat-label>
            <input matInput formControlName="childTax" placeholder="Enter child tax">
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label>Rental Income</mat-label>
            <input matInput formControlName="rentalIncome" placeholder="Enter rental income">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Family Support</mat-label>
            <input matInput formControlName="familySupport" placeholder="Enter family support">
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label>Any Other Income</mat-label>
            <input matInput formControlName="otherIncome" placeholder="Enter any other income">
          </mat-form-field>
        </div>
      </div>

      <!-- Assets Section -->
      <div class="form-section">
        <div class="section-header">
          <h3 class="section-title">
            <mat-icon>home</mat-icon>
            Assets
          </h3>
          <button type="button" mat-raised-button color="primary" (click)="addMortgage()" class="add-btn">
            <mat-icon>add</mat-icon>
            Add Mortgage
          </button>
        </div>

        <div class="items-list" *ngIf="mortgageList.length > 0">
          <div *ngFor="let mortgage of mortgageList; let i = index" class="item-row">
            <mat-form-field class="form-field">
              <mat-label>{{ getMortgageLabel(i) }}</mat-label>
              <input matInput [(ngModel)]="mortgage.value" [ngModelOptions]="{standalone: true}" placeholder="Enter value">
            </mat-form-field>

            <button type="button" mat-icon-button color="warn" (click)="removeMortgage(i)" class="remove-btn">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div *ngIf="mortgageList.length === 0" class="empty-state">
          <p>No mortgage information added yet</p>
        </div>

        <!-- Property Value and LOP -->
        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Property Value</mat-label>
            <input matInput formControlName="propertyValue" placeholder="Enter property value">
          </mat-form-field>

          <div class="radio-group">
            <label>LOP Needed</label>
            <mat-radio-group formControlName="lopNeeded" class="radio-options">
              <mat-radio-button value="yes">Yes</mat-radio-button>
              <mat-radio-button value="no">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <!-- Vehicle Information Section -->
      <div class="form-section">
        <h3 class="section-title">
          <mat-icon>directions_car</mat-icon>
          Vehicle Information
        </h3>

        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Vehicle Model</mat-label>
            <input matInput formControlName="vehicleModel" placeholder="Enter vehicle model">
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label>Vehicle Year</mat-label>
            <input matInput type="number" formControlName="vehicleYear" placeholder="Enter year">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Finance Amount</mat-label>
            <input matInput type="number" formControlName="vehicleFinance" placeholder="Enter finance amount">
          </mat-form-field>
        </div>
      </div>

      <!-- Business Information Section -->
      <div class="form-section">
        <h3 class="section-title">
          <mat-icon>business</mat-icon>
          Business Information
        </h3>

        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Business Name</mat-label>
            <input matInput formControlName="businessName" placeholder="Enter business name">
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label>HST</mat-label>
            <input matInput formControlName="businessHst" placeholder="Enter HST number">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field class="form-field">
            <mat-label>Article of Incorporation</mat-label>
            <input matInput formControlName="businessArticle" placeholder="Enter article of incorporation">
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label>Business Debt</mat-label>
            <input matInput type="number" formControlName="businessDebt" placeholder="Enter business debt">
          </mat-form-field>
        </div>
      </div>

      <!-- Notes Section -->
      <div class="form-section">
        <h3 class="section-title">
          <mat-icon>note</mat-icon>
          Notes
        </h3>

        <mat-form-field class="form-field full-width">
          <mat-label>Additional Notes</mat-label>
          <textarea matInput formControlName="note" placeholder="Enter any additional notes" rows="4"></textarea>
        </mat-form-field>
      </div>

      <!-- Terms Section -->
      <div class="form-section">
        <h3 class="section-title">
          <mat-icon>description</mat-icon>
          Terms
        </h3>

        <mat-form-field class="form-field full-width">
          <mat-label>Terms and Conditions</mat-label>
          <textarea matInput formControlName="terms" placeholder="Enter terms and conditions" rows="4"></textarea>
        </mat-form-field>
      </div>
    </form>
  </div>

  <!-- Footer -->
  <div class="create-footer">
    <button mat-raised-button (click)="onCancel()" class="cancel-btn" [disabled]="isSubmitting">
      Cancel
    </button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!form.valid || isSubmitting" class="submit-btn">
      <mat-icon *ngIf="!isSubmitting">save</mat-icon>
      <mat-spinner *ngIf="isSubmitting" diameter="20" class="spinner"></mat-spinner>
      {{ isSubmitting ? 'Creating...' : 'Create First Meeting' }}
    </button>
  </div>
</div>
